import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';

// action creators
import { closeMessage } from 'messages';

// components
import LoadingWrapperContainer from 'api/loading/LoadingWrapperContainer';
import MessagePanel from 'messages/MessagePanel';
import QuitFlowModalContainer from 'common/modals/QuitFlowModalContainer';
import ScriptFlowBody from 'common/ScriptFlowBody';
import ScriptFlowHeader from 'common/ScriptFlowHeader';
import ScriptOptions from './ScriptOptions';

let Create = ({
  initialLoadIsInProgress,
  isAppMode,
  messages,
  onClickCancel
}) => {

  const classString = classNames({
    'vra-create': true,
    'vra-route-container': true,
    'vra-route-container--script-flow': true,
    'vra-route-container--create': true,
    'vra-route-container--app-mode': isAppMode
  });
  return (
    <section className={classString} data-test-id={'script-can-create-all'}>
      <MessagePanel
        closeMessage={closeMessage}
        isToolbarShown={false}
        messages={messages}
      />
      <ScriptFlowHeader
        isVisible={!isAppMode }
        onClickCancel={onClickCancel}
        showOwnerName={true}
      />
      <ScriptFlowBody
        isAppMode={isAppMode}
        isFinalStep={false}
        showFooter={false}
        step={0}
      >
        <LoadingWrapperContainer initialLoadIsInProgress={initialLoadIsInProgress}>
          <ScriptOptions />
        </LoadingWrapperContainer>
      </ScriptFlowBody>
      <QuitFlowModalContainer />
    </section>
  );
};

Create.propTypes = {
  initialLoadIsInProgress: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  messages: propTypes.array.isRequired,
  onClickCancel: propTypes.func.isRequired
};

export default Create;
